import { render } from "./LockscreenComponent.vue?vue&type=template&id=72bab412"
import script from "./LockscreenComponent.vue?vue&type=script&lang=js"
export * from "./LockscreenComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__